import React, { useState } from 'react';
import type { AspectRatio } from '../types';

interface VideoPlayerProps {
  url: string;
  /** Known project aspect ratio; used before metadata loads. */
  aspectRatio?: AspectRatio;
}

function isPortraitRatio(ratio: AspectRatio | null | undefined): boolean {
  return ratio === '9:16';
}

export default function VideoPlayer({ url, aspectRatio }: VideoPlayerProps) {
  const [detectedPortrait, setDetectedPortrait] = useState(false);
  const portrait = isPortraitRatio(aspectRatio) || detectedPortrait;

  return (
    <div className={portrait ? 'flex justify-center' : undefined}>
      <div
        className={
          portrait
            ? 'w-full max-w-[min(420px,100%)] max-h-[min(70vh,720px)]'
            : 'w-full'
        }
      >
        <video
          controls
          src={url}
          className={
            portrait
              ? 'mx-auto block h-auto max-h-[min(70vh,720px)] w-auto max-w-full rounded-lg bg-black'
              : 'w-full rounded-lg bg-black'
          }
          preload="metadata"
          onLoadedMetadata={(e) => {
            const video = e.currentTarget;
            if (video.videoHeight > video.videoWidth) {
              setDetectedPortrait(true);
            }
          }}
        />
      </div>
    </div>
  );
}
